import React, { useContext } from 'react';
const LengthContext = React.createContext(6);
export const useLengthContext = () => useContext(LengthContext);
const SelectionContext = React.createContext(null);
export const useSelectionContext = () => useContext(SelectionContext);
export const Context = (props) => (<LengthContext.Provider value={props.length}>
		<SelectionContext.Provider value={props.selection}>{props.children}</SelectionContext.Provider>
	</LengthContext.Provider>);
